export default "__VITE_ASSET__2bXHglLk__"